// TODO: CONVERT TO TYPESCRIPT
import React from 'react'
import PropTypes from 'prop-types'
import abbreviate from 'number-abbreviate'

class MinRating extends React.Component {
  isSelected = () => {
    return !this.isDisabled() && this.props.selectedRating === this.props.rating
  }

  isDisabled = () => {
    return this.props.ratingCounts[this.props.rating] === 0
  }

  isActive = () => {
    return !this.isDisabled() && !this.isSelected()
  }

  renderRadio = (minRatingId) => {
    return (
      <input
        type='radio'
        disabled={this.isDisabled()}
        checked={this.props.selectedRating === this.props.rating}
        onChange={(e) => e.stopPropagation()}
        className='radio'
        id={minRatingId}
        value={this.props.rating}
      />
    )
  }

  renderTitle = (rating) => {
    if (rating) {
      return <>{rating} Stars and Up</>
    } else {
      return 'All Reviews'
    }
  }

  renderActiveStars = rating => {
    return [...Array(rating)].map((e, i) => <i className='fas fa-star star-color' key={`star-${i}`} />)
  }

  renderInactiveStars = rating => {
    return [...Array(5 - rating)].map((e, i) => <i className='fas fa-star grey-c' key={`star-grey-${i}`} />)
  }

  renderClass = () => {
    if (this.isDisabled()) {
      return 'disabled'
    } else if (this.isSelected()) {
      return 'selected'
    } else {
      return 'active'
    }
  }

  renderStars = rating => {
    if (rating !== 0) {
      return (
        <>
          {this.renderActiveStars(rating)}
          {this.renderInactiveStars(rating)}
        </>
      )
    }
  }

  render () {
    const { rating } = this.props

    // add random number so that mobile and desktop versions have distinct ids
    const minRatingId = `min-rating-${rating}-${Math.floor(Math.random() * 1000)}`

    return (
      <div
        className={`grid-x min-rating align-middle ${this.renderClass()}`}
        onClick={(e) => {
          this.isDisabled() ? e.stopPropagation() : this.props.onChange(rating)
        }}
      >
        <div className='cell shrink'>
          {this.renderRadio(minRatingId)}
        </div>
        <div className='cell auto'>
          <label htmlFor={minRatingId}>
            {this.renderStars(rating)}
            {this.renderTitle(rating)}
          </label>
        </div>
        <div className='cell shrink count'>
          {abbreviate(this.props.ratingCounts[rating], 1)}
        </div>
      </div>
    )
  }
}

MinRating.propTypes = {
  rating: PropTypes.number.isRequired,
  ratingCounts: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  selectedRating: PropTypes.number.isRequired
}

export default MinRating
